import { Dialog } from '@mui/material';
import DialogBase from './DialogBase';

const ConfirmDialog = ({
  id,
  content,
  showCancel,
  confirmText,

  onSuccess,
  onExit,
}) => (
  <Dialog open={content} fullWidth>
    <DialogBase
      id={id}
      showCancel={showCancel}
      confirmText={confirmText}
      submit={onSuccess}
      onExit={onExit}
    >
      {content}
    </DialogBase>
  </Dialog>
);

export default ConfirmDialog;
